export default __webpack_public_path__ + "static/media/client-couple.245a78f2.webp";